/**
 * AdminWidgetsSpec.company-dynamic.js — 회사별 위젯을 코드에서 만들어 낸다 (2026-09-10, 4단계)
 *
 * 문제: 회사별 위젯 10종의 회사 목록이 `['PINE','DOT','LNJ']` 로 박혀 있었다.
 *   그래서 **미팅링크의 유기자차(SUNCREAM)는 회사별 위젯이 0개**였다 — 급여·인센티브·계약갱신·
 *   콜·계약취소·매출·점수·미팅주간·정산·마케터1:1 이 전부 없다. 회사가 늘 때마다 사람이
 *   목록을 고쳐야 했고, 고치지 않으면 그 회사 관리자는 상황판이 텅 빈다.
 *
 * 다행히 스펙을 만드는 함수들은 처음부터 회사코드를 인자로 받게 돼 있었다(payrollEntry(cc) 등).
 *   박혀 있던 것은 목록뿐이라, 위젯 코드에서 회사코드를 되읽어 같은 함수를 부르면 된다.
 *
 * 기존 3사(PINE·DOT·LNJ)의 정적 스펙은 **그대로 둔다** — 먼저 정적 조회가 맞고,
 *   여기는 거기서 못 찾은 코드만 받는다. 즉 기존 화면의 동작은 한 톨도 바뀌지 않는다.
 *
 * ⚠ 접두사가 겹친다: admin_tm_ / admin_tmscore_ / admin_tmmeet_.
 *   그래서 **긴 접두사부터** 맞춰 본다. 또 회사코드 자리에 아무 단어나 오면 안 되므로
 *   영문·숫자만 허용한다. 새 위젯을 이 접두사로 만들 때는 회사별인지 먼저 확인할 것.
 */
import { STAFF_COMPANY_ENTRY_BUILDERS } from './AdminWidgetsSpec.staff-companies';
import { SALES_COMPANY_ENTRY_BUILDERS } from './AdminWidgetsSpec.sales-companies';
import { FINANCE_COMPANY_ENTRY_BUILDERS } from './AdminWidgetsSpec.finance-companies';

const BUILDERS = {
  ...STAFF_COMPANY_ENTRY_BUILDERS,
  ...SALES_COMPANY_ENTRY_BUILDERS,
  ...FINANCE_COMPANY_ENTRY_BUILDERS,
};

// 긴 접두사 우선 (admin_tmscore 가 admin_tm 보다 먼저 걸려야 한다)
const PREFIXES = Object.keys(BUILDERS).sort((a, b) => b.length - a.length);

/** 위젯 코드 → { prefix, companyCode } (회사별 위젯이 아니면 null) */
function parseCompanyWidgetCode(code) {
  const text = String(code || '');
  for (const prefix of PREFIXES) {
    if (!text.startsWith(`${prefix}_`)) continue;
    const suffix = text.slice(prefix.length + 1);
    if (!/^[a-z0-9]+$/.test(suffix)) continue;
    return { prefix, companyCode: suffix.toUpperCase() };
  }
  return null;
}

export function isCompanyWidgetCode(code) {
  return parseCompanyWidgetCode(code) !== null;
}

/** 회사별 위젯 spec 생성 (없는 코드면 null) */
export function buildCompanyWidgetSpec(code) {
  const parsed = parseCompanyWidgetCode(code);
  if (!parsed) return null;
  const [, spec] = BUILDERS[parsed.prefix](parsed.companyCode);
  return spec;
}
